import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { safeReturnTo } from './returnTo';
import { login, userManager, type SigninState } from './userManager';

/** /auth-callback: завершает вход и возвращает на запрошенную страницу. */
export function AuthCallback() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return; // StrictMode вызывает эффект дважды, а код авторизации одноразовый
    done.current = true;
    userManager
      .signinRedirectCallback()
      .then((user) => {
        const state = user.state as SigninState | undefined;
        navigate(safeReturnTo(state?.returnTo), { replace: true });
      })
      .catch(() => setError(true));
  }, [navigate]);

  return (
    <div className="center-screen">
      {error ? (
        <div className="empty">
          {t('auth.callbackFailed')}
          <br />
          <button className="btn btn-primary" onClick={() => void login('/')}>
            {t('auth.loginAgain')}
          </button>
        </div>
      ) : (
        <div className="loading">{t('auth.finishing')}</div>
      )}
    </div>
  );
}
